module.exports = __webpack_public_path__ + "static/Digital_Marketing-dad15b8065af10578919064f49e50758.svg";